exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".download-dropdown {\n  position: absolute;\n  right: 12px;\n  top: -70px;\n  z-index: 10;\n}\n.download-dropdown button {\n  cursor: pointer;\n}\n.download-dropdown button:disabled {\n  cursor: not-allowed;\n}\ndiv.icon {\n  cursor: pointer;\n  height: 38px;\n  width: 38px;\n  background: #E8E8E8;\n  border-radius: 100%;\n  color: #808285;\n  font-size: 20px;\n  padding-top: 4px;\n  text-align: center;\n}\ndiv.icon:hover {\n  background: #cfcfcf;\n  color: #67696b;\n  cursor: pointer;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/shared/download-selector/download-selector.component.less
// module id = ../../../../../src/app/shared/download-selector/download-selector.component.less
// module chunks = 2